import React, { useState, useEffect, useMemo, useRef } from "react";
import { useNavigate, useLocation } from "react-router";
import "../shuttle_bus_booking.css";
import { useDispatch, useSelector } from "react-redux";
import { Loader } from "@progress/kendo-react-indicators";

import { PermissionDeninedPage } from "../../../components/reusableItems/permission_denined";
import { checkPermission, getUserPermission } from "../../../config/permission_helper";
import { Stepper } from "@progress/kendo-react-layout";
import { CustomStep } from "../../../components/common/custom_steps";
import { SHUTTLE_BUS_BOOKING_SET_STATION_LIST, SHUTTLE_BUS_BOOKING_SET_STATION_UPDATE } from "../../../routes";
import { fetchSetStationAudit, fetchSetStationDetail } from "../../../store/shuttle_bus_booking/set_station";
import momentTZ from 'moment-timezone';
import MapIcon from "../../../assets/shuttle_bus_booking/ic_pin.svg";
import EditIcon from "../../../assets/common/EditIcon.svg";


export const ShuttleBusBookingSetStationDetail = () => {
  const navigate = useNavigate();
  let { search } = useLocation();
  const dispatch = useDispatch();
  const query = new URLSearchParams(search);
  const id = query.get("id");

  const { detail_data, detail_loading, audit_data, audit_loading } = useSelector(
    (state) => state.shuttleBusSetStation
  );

  const userPermissions = getUserPermission();

  const viewPermssion = checkPermission(
    userPermissions,
    "bus_booking.access_bus_booking_station"
  );

  const updatePermssion = checkPermission(
    userPermissions,
    "bus_booking.update_bus_booking_station"
  );

  const getData = async () => {
    dispatch(fetchSetStationDetail(id));
    dispatch(fetchSetStationAudit(id));

  };


  useEffect(() => {
    getData();
  }, [id]);

  const locationString = detail_data?.station_name || '';
  const parts = locationString.match(/^(.*)\((.*)\)$/);
  const mainName = parts ? parts[1].trim() : locationString;
  const subtitle = parts ? `(${parts[2].trim()})` : ' ';

  return (
    <>
      {viewPermssion ? (
        <div className="inventory_container">

          {
            detail_loading && (
              <Loader
                type="converging-spinner"
                style={{
                  width: "100%",
                  height: "calc(100% - 75px)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: "#ffffff4d",
                  position: "absolute",
                  zIndex: "999",
                }}
              />
            )
          }
          <div className="shuttle_bus_booking_detail_main_box">
            <div className="shuttle_bus_booking_detail_child_box">
              <div className="shuttle_bus_booking_detail_left_box">
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <div
                    className="shuttle_bus_booking_detail_back"
                    onClick={() => navigate(SHUTTLE_BUS_BOOKING_SET_STATION_LIST)}
                  >
                    <span class="k-icon k-font-icon k-i-arrow-chevron-left" />
                    Back
                  </div>

                  {
                    updatePermssion && <div
                      className="shuttle_bus_booking_detail_edit"
                      onClick={() => navigate(`${SHUTTLE_BUS_BOOKING_SET_STATION_UPDATE}?id=${id}`)}
                    >
                      <img src={EditIcon} />
                      Edit
                    </div>
                  }


                </div>
                <div className={"shuttle_bus_booking_detail_child_box_main_detail_box"}>
                  <div>
                    <div className="shuttle_bus_booking_detail_child_box_main_detail_items">
                      <div className="shuttle_bus_booking_detail_child_box_main_detail_items_title shuttle_bus_booking_detail_center_item shuttle_bus_booking_detail_padding_bottom">
                        Station ID
                      </div>
                      <div className="shuttle_bus_booking_detail_child_box_main_detail_items_splitter" />
                      <div className="shuttle_bus_booking_detail_center_item shuttle_bus_booking_detail_child_box_main_detail_items_subdetail shuttle_bus_booking_detail_padding_bottom">
                        {detail_data?.station_id}
                      </div>
                    </div>

                    <div className="shuttle_bus_booking_detail_child_box_main_detail_items">
                      <div className="shuttle_bus_booking_detail_child_box_main_detail_items_title shuttle_bus_booking_detail_center_item shuttle_bus_booking_detail_padding_bottom">
                        Station Name
                      </div>
                      <div className="shuttle_bus_booking_detail_child_box_main_detail_items_splitter" />
                      <div className="shuttle_bus_booking_detail_center_item shuttle_bus_booking_detail_child_box_main_detail_items_subdetail shuttle_bus_booking_detail_padding_bottom">
                        {detail_data?.station_name}
                      </div>
                    </div>

                    <div className="shuttle_bus_booking_detail_child_box_main_detail_items">
                      <div className="shuttle_bus_booking_detail_child_box_main_detail_items_title shuttle_bus_booking_detail_center_item shuttle_bus_booking_detail_padding_bottom">
                        Latitude
                      </div>
                      <div className="shuttle_bus_booking_detail_child_box_main_detail_items_splitter" />
                      <div className="shuttle_bus_booking_detail_center_item shuttle_bus_booking_detail_child_box_main_detail_items_subdetail shuttle_bus_booking_detail_padding_bottom">
                        {detail_data?.latitude}
                      </div>
                    </div>

                    <div className="shuttle_bus_booking_detail_child_box_main_detail_items">
                      <div className="shuttle_bus_booking_detail_child_box_main_detail_items_title shuttle_bus_booking_detail_center_item shuttle_bus_booking_detail_padding_bottom">
                        Longitude
                      </div>
                      <div className="shuttle_bus_booking_detail_child_box_main_detail_items_splitter" />
                      <div className="shuttle_bus_booking_detail_center_item shuttle_bus_booking_detail_child_box_main_detail_items_subdetail shuttle_bus_booking_detail_padding_bottom">
                        {detail_data?.longitude}
                      </div>
                    </div>

                    <div className="shuttle_bus_booking_detail_child_box_main_detail_items">
                      <div className="shuttle_bus_booking_detail_child_box_main_detail_items_title shuttle_bus_booking_detail_center_item shuttle_bus_booking_detail_padding_bottom">
                        Created at
                      </div>
                      <div className="shuttle_bus_booking_detail_child_box_main_detail_items_splitter" />
                      <div className="shuttle_bus_booking_detail_center_item shuttle_bus_booking_detail_child_box_main_detail_items_subdetail shuttle_bus_booking_detail_padding_bottom">
                        {detail_data?.created_at ? momentTZ.tz(`${detail_data?.created_at}`, 'Asia/Singapore').local().format('DD-MM-YYYY hh:mm A') : ""}
                      </div>
                    </div>

                    <div className="shuttle_bus_booking_detail_child_box_main_detail_items">
                      <div className="shuttle_bus_booking_detail_child_box_main_detail_items_title shuttle_bus_booking_detail_center_item shuttle_bus_booking_detail_padding_bottom">
                        Created by
                      </div>
                      <div className="shuttle_bus_booking_detail_child_box_main_detail_items_splitter" />
                      <div className="shuttle_bus_booking_detail_center_item shuttle_bus_booking_detail_child_box_main_detail_items_subdetail shuttle_bus_booking_detail_padding_bottom">
                        {detail_data?.created_by?.username}
                      </div>
                    </div>

                    <div className="shuttle_bus_booking_detail_child_box_main_detail_items">
                      <div className="shuttle_bus_booking_detail_child_box_main_detail_items_title" style={{ marginTop: '10px' }}>
                        Station info
                      </div>
                      <div className="shuttle_bus_booking_detail_child_box_main_detail_items_splitter" />
                      <div className="shuttle_bus_booking_detail_center_item shuttle_bus_booking_detail_child_box_main_detail_items_subdetail shuttle_bus_booking_detail_padding_bottom">
                        <div className="location-main-container">
                          <div className="location-container">
                            <div className="pin-icon">
                              <img alt="" src={MapIcon} className="shuttle_bus_booking_map_icon" />
                            </div>
                            <div className="text-container">
                              <span className="main-name">{mainName}</span>
                              <span className="subtitle">{subtitle}</span>
                              <div className="coordinates">{`${detail_data?.longitude},${detail_data?.latitude}`}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>



                  </div>
                </div>


              </div>
              <div className="shuttle_bus_booking_detail_right_box">


                <div className="shuttle_bus_booking_detail_right_box_action_main_box">
                  <div className="shuttle_bus_booking_detail_right_box_action_title">
                    Activity Trail
                  </div>
                  <div className={audit_data.length <= 1 && "audit_bar_hide"}>
                    {audit_loading ? (
                      <Loader
                        type="converging-spinner"
                        style={{
                          width: "100%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          background: "#ffffff4d",
                        }}
                      />
                    ) : (
                      <Stepper
                        orientation={"vertical"}
                        items={audit_data}
                        item={CustomStep}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>


          </div>

        </div>
      ) : (
        <PermissionDeninedPage
          height={"calc(100% - 76px)"}
          title={"Sorry, You don't have permission to access this page!"}
        />
      )}

    </>
  );
};
